import PropTypes from 'prop-types';

import * as style from './style.module.css';

const Card = ({ children, fullscreen = false, isSelected = false, theme = '' }) => {
    return (
        <div className={fullscreen ? style.fullscreen : ''}>
            <div className={`${style.card} ${isSelected ? style.selected : ''} ${style[theme]}`}>{children}</div>
        </div>
    );
};

Card.propTypes = {
    children: PropTypes.node,
    fullscreen: PropTypes.bool,
    isSelected: PropTypes.bool,
    theme: PropTypes.oneOf(['', 'booking', 'login', 'subsection']),
};

export default Card;
